const _customeObj = {
  paper: {
    boxShadow: "2px 2px 4px 3px rgba(90,90,90,0.1)",
  },
};

export default _customeObj;
